import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';

const TypeFormatter = ({ data }) => {
  const intl = useIntl();
  return (
    <>
      {data
        ? intl.formatMessage({
            id: 'dataGrid.formatters.batches.type.import',
            defaultMessage: 'Import',
            description: 'The import column value for column type',
          })
        : intl.formatMessage({
            id: 'dataGrid.formatters.batches.type.export',
            defaultMessage: 'Export',
            description: 'The export column value for column type',
          })}
    </>
  );
};

TypeFormatter.propTypes = {
  data: PropTypes.bool,
};

TypeFormatter.defaultProps = {
  data: false,
};

export default TypeFormatter;
